import { render, staticRenderFns } from "./claimPolicyInfoBuLu.vue?vue&type=template&id=6c1a9f1e&scoped=true&"
import script from "./claimPolicyInfoBuLu.vue?vue&type=script&lang=js&"
export * from "./claimPolicyInfoBuLu.vue?vue&type=script&lang=js&"
import style0 from "./claimPolicyInfoBuLu.vue?vue&type=style&index=0&id=6c1a9f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a9f1e",
  null
  
)

export default component.exports